import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class JobsListFallbackRadiusInfo extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            proximityCloseIcon: '.m-jobsListFallbackRadiusInfo__closeIcon',
            desiredLocationsLink: '.m-jobsListFallbackRadiusInfo__desiredLocationsLink',
        };
    }

    domEvents() {
        if (this.dom.proximityCloseIcon) {
            this.dom.proximityCloseIcon.addEventListener('click', () => this.removeFallbackRadiusBox());
        }
        if (this.dom.desiredLocationsLink) {
            this.dom.desiredLocationsLink.addEventListener('click', (e) => {
                e.preventDefault();
                this.events.emit('openEditModal', '/profil/lebenslauf/wunschjob?matching=true', 'Wunschort');
            });
        }
    }

    removeFallbackRadiusBox() {
        this.updateProps({ fallbackRadius: !this.props.fallbackRadius }, true);
    }

    getPropsFromDom() {
        return {
            fallbackRadius: !!this.props.fallbackRadius,
        };
    }
}
